<template>
  <v-btn
    v-if="button"
    color="primary"
    :href="supportLink"
  >
    <slot>{{ supportEmail }}</slot>
  </v-btn>
  <a
    v-else
    :href="supportLink"
  ><slot>{{ supportEmail }}</slot></a>
</template>

<script>
import { supportEmail } from '../config/app'

const mailToParams = ['subject', 'body']
const mailProps = mailToParams.reduce(
  (acc, param) => ({ ...acc, [param]: { type: String, default: null } }),
  {}
)

export default {
  name: 'SupportEmail',
  props: {
    ...mailProps,
    button: { type: Boolean, default: false }
  },
  data: function () {
    return {
      supportEmail
    }
  },
  computed: {
    supportLink() {
      return `mailto:${supportEmail}${this.queryString}`
    },
    queryString() {
      return this.linkParams ? `?${this.linkParams}` : ''
    },
    linkParams() {
      return mailToParams
        .map((paramName) => this.toParamString(paramName))
        .filter(paramString => paramString !== null)
        .join('&')
    }
  },
  methods: {
    toParamString(paramName) {
      const value = this[paramName]
      return value
        ? `${encodeURIComponent(paramName)}=${encodeURIComponent(value)}`
        : null
    }
  }
}
</script>
